/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { shape, node, number, func, bool, string } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux/actions";
import { selectors } from "reducers/widgets";

import WidgetList from "pages/desktop/widgets/WidgetList";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import WidgetHeader from "./_components/WidgetHeader";
import EcheqRecivedWidgetItem from "./_components/EcheqRecivedWidgetItem";

const WIDGET_NAME = "echeqsReceived";

class EcheqsReceived extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        echeqsPages: number.isRequired,
        isEditable: bool,
        dispatch: func.isRequired,
        errorMsg: string.isRequired,
        isDesktop: bool,
    };

    static defaultProps = {
        closeButton: null,
        isEditable: false,
        isDesktop: true,
    };

    render() {
        const { closeButton, errorMsg, draggableItemProps, echeqsPages, dispatch, isEditable, isDesktop } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetEcheqs" };

        return (
            <>
                <WidgetList
                    item={EcheqRecivedWidgetItem}
                    keyExtractor={(item) => item.idProduct}
                    name={WIDGET_NAME}
                    isEditable={isEditable}
                    isDesktop={isDesktop}
                    close={closeButton}>
                    {(list) => (
                        <div
                            role={isEditable ? "button" : "none"}
                            className={!isDesktop ? "widget echeqs-widget" : "echeqs-widget"}
                            {...uiAutomationProp}
                            {...draggableItemProps}
                            aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                            <WidgetHeader
                                title={i18nUtils.get("received.echeqs")}
                                action={
                                    <>
                                        {echeqsPages > 1 && !isEditable && !errorMsg && (
                                            <Button
                                                onClick={() => {
                                                    dispatch(push("/echeqs"));
                                                }}
                                                bsStyle="outline"
                                                label="menu.seemore.label"
                                                type="button"
                                                image="images/arrow-right-blue.svg"
                                            />
                                        )}
                                    </>
                                }
                            />
                            <div className="widget__content">{list}</div>
                        </div>
                    )}
                </WidgetList>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { data, errorMsg, isFetching } = selectors.getWidget(state, WIDGET_NAME);

    return {
        isFetching,
        echeqsPages: data.totalPages,
        errorMsg,
    };
};

export default connect(mapStateToProps)(EcheqsReceived);
